export default "__VITE_ASSET__CP7N6x$c__"